import { createSelector } from '@reduxjs/toolkit';
import { selectHouseAddress } from './selectHouseAddress';
import { selectSeoPageTitle } from '../seoData';

export const selectPageTitle = createSelector(selectSeoPageTitle, selectHouseAddress, (seoPageTitle, address) => {
  if (seoPageTitle) {
    return seoPageTitle;
  }

  const addressStr = address
    .reduce((result, { type, fullName }) => (['street', 'house'].includes(type) ? [...result, fullName] : result), [])
    .join(', ');

  return `Дом по адресу ${addressStr}`;
});
